import request from '@/plugins/axios'

export function getAccountTask(params) {
  // 获取帐号落查任务
  return request({
    url: '/detect/accounts',
    method: 'get',
    params
  })
}
export function addAccountTask(data) {
  // 添加帐号落查任务
  return request({
    url: '/detect/accounts',
    method: 'post',
    data
  })
}

export function getPhoneTask(params) {
  // 获取手机号落查任务
  return request({
    url: '/detect/phones',
    method: 'get',
    params
  })
}
export function addPhoneTask(data) {
  // 添加手机号落查任务
  return request({
    url: '/detect/phones',
    method: 'post',
    data
  })
}

export function getAccountHitRateTask(params) {
  // 获取手机号落查任务
  return request({
    url: '/detect/account_hit_rate',
    method: 'get',
    params
  })
}

export function addAccountHitRateTask(data) {
  // 添加手机号落查任务
  return request({
    url: '/detect/account_hit_rate',
    method: 'post',
    data
  })
}
